import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutGrid,
  CalendarDays,
  Shield,
  LogOut
} from "lucide-react";

export default function SkillsTrainerSidebar() {
  const [collapsed, setCollapsed] = useState(true);
  const location = useLocation();
  const brandLogo = `${process.env.PUBLIC_URL}/NuvioLogo.png?v=20260314c`;

  const isActive = (path) => location.pathname === path;
  const isSwotRoute = location.pathname.startsWith("/skills-trainer/swot");

  const navItem = (to, Icon, label, activeOverride) => (
    <Link
      to={to}
      className={`flex items-center gap-3 px-3 py-3 rounded-lg transition-all ${
        activeOverride || isActive(to)
          ? "bg-blue-600 text-white shadow-lg shadow-blue-900/20"
          : "text-gray-400 hover:bg-gray-800 hover:text-white"
      }`}
    >
      <Icon size={20} className="min-w-[20px]" />
      <span className={`whitespace-nowrap transition-all ${collapsed ? "opacity-0 w-0" : "opacity-100"}`}>
        {label}
      </span>
    </Link>
  );

  return (
    <aside
      className={`hidden md:flex flex-col bg-gray-900 text-gray-100 h-screen overflow-hidden transition-all duration-300 border-r border-gray-800 ${
        collapsed ? "w-20" : "w-64"
      }`}
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
    >
      <div className="flex flex-col h-full">
        <div className="p-5 border-b border-gray-800 flex flex-col items-center justify-center min-h-[80px]">
          <img
            src={brandLogo}
            alt="Nuvio"
            className="w-8 h-8 rounded-lg object-cover shadow-sm mb-2"
          />
          <h1 className={`text-xl font-bold tracking-tight whitespace-nowrap transition-all duration-300 ${collapsed ? "opacity-0 w-0" : "opacity-100"}`}>
            Skills Trainer
          </h1>
        </div>

        <nav className="flex-1 px-3 py-6 space-y-2 overflow-y-auto">
          {navItem("/skills-trainer", LayoutGrid, "Dashboard")}
          {navItem("/skills-trainer/swot", Shield, "SWOT Hub", isSwotRoute)}
          {navItem("/schedule", CalendarDays, "Schedule")}
        </nav>

        <div className="px-3 pb-6">
          <Link
            to="/logout"
            className="flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-gray-400 hover:bg-gray-800 hover:text-white"
          >
            <LogOut size={20} className="min-w-[20px]" />
            <span className={`whitespace-nowrap transition-all ${collapsed ? "opacity-0 w-0" : "opacity-100"}`}>
              Logout
            </span>
          </Link>
        </div>
      </div>
    </aside>
  );
}
